import Settings from '@settings/settings';

export const SaveFile = async (studyRef: string, fileName: string, token: string) => {
    // create a new handle with the file picker
    const newHandle = await window.showSaveFilePicker({ suggestedName: fileName, startIn: 'downloads' });

    const dl = await fetch(`${Settings.api.url()}/api/dataquality/${studyRef}/downloadReport/${fileName}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
        },
    });

    if (!dl.ok) {
        throw new Error('Failed to get file from OPRA');
    }

    const reader = dl.body?.getReader();

    // create a FileSystemWritableFileStream to write to
    const writableStream = await newHandle.createWritable();

    const readableStream = new ReadableStream({
        start(controller) {
            async function pump(): Promise<void> {
                const { done, value } = await reader!.read();
                // When no more data needs to be consumed, close the stream
                if (done) {
                    controller.close();
                    return;
                }
                // Enqueue the next data chunk into our target stream
                controller.enqueue(value);
                return pump();
            }
            return pump();
        },
    });

    // Pipe our streamed response data to the file write stream
    // eslint-disable-next-line no-void
    void readableStream.pipeTo(writableStream);
};
